import {ClientCommands} from './clientCommands';

export abstract class JsToClientCommand<T extends {}> {
    private name: ClientCommands;
    private params: T;

    protected constructor(name: ClientCommands, params: T = {} as T) {
        this.name = name;
        this.params = params;
    }

    public getName(): ClientCommands {
        return this.name;
    }

    public getParams(): T {
        return this.params;
    }
}
